import React from "react";
import OrderComponent from "../components/Order";

const Order = () => {
  return <OrderComponent />;
};

export default Order;
